import React from 'react';
import { TouchableWithoutFeedback, StyleSheet, View } from 'react-native';
import Image from '@kds/image';
import IconBack from '@/assets/icon/icon_back.png';

const styles = StyleSheet.create({
    box: {
        position: 'relative',
        width: '100%',
        height: 48,
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#fff',
        borderBottomWidth: 1,
        borderBottomColor: '#EAEAEA',
    },
    left: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginLeft: 19,
        width: 40,
    },
    leftIcon: {
        width: 40,
        height: 40,
    },
    title: {
        position: 'absolute',
        paddingHorizontal: 59,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'center',
        flexGrow: 1,
        textAlign: 'center',
    },
});

const Navbar = (props: { onBack: () => void; title: string }) => {
    return (
        <TouchableWithoutFeedback onPress={props.onBack}>
            <View style={styles.box}>
                <View style={styles.left}>
                    <Image style={styles.leftIcon} source={IconBack} />
                </View>
                <View style={styles.title}>{props.title}</View>
            </View>
        </TouchableWithoutFeedback>
    );
};

export default Navbar;
